(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["classrooms/includes/components/_bulk_qr_block_message.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "sure_to_continue") || runtime.contextOrFrameLookup(context, frame, "sure_to_exit")) {
output += "\n    ";
var t_1;
t_1 = (lineno = 1, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["node_modules/@discoveryedu/nebula-icons/nebula.svg#warning"]));
frame.set("status_svg_href", t_1, true);
if(frame.topLevel) {
context.setVariable("status_svg_href", t_1);
}
if(frame.topLevel) {
context.addExport("status_svg_href", t_1);
}
output += "\n    ";
var t_2;
t_2 = "qr-block-message__icon--warn";
frame.set("status_svg_class", t_2, true);
if(frame.topLevel) {
context.setVariable("status_svg_class", t_2);
}
if(frame.topLevel) {
context.addExport("status_svg_class", t_2);
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "sure_to_continue")) {
output += "\n        ";
var t_3;
t_3 = (lineno = 4, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Confirm QR Code Issue"]));
frame.set("title", t_3, true);
if(frame.topLevel) {
context.setVariable("title", t_3);
}
if(frame.topLevel) {
context.addExport("title", t_3);
}
output += "\n    ";
;
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "is_complete")) {
output += "\n    ";
var t_4;
t_4 = (lineno = 7, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["node_modules/@discoveryedu/nebula-icons/nebula.svg#check-circle"]));
frame.set("status_svg_href", t_4, true);
if(frame.topLevel) {
context.setVariable("status_svg_href", t_4);
}
if(frame.topLevel) {
context.addExport("status_svg_href", t_4);
}
output += "\n    ";
var t_5;
t_5 = "qr-block-message__icon--success";
frame.set("status_svg_class", t_5, true);
if(frame.topLevel) {
context.setVariable("status_svg_class", t_5);
}
if(frame.topLevel) {
context.addExport("status_svg_class", t_5);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "sure_to_exit")) {
output += "\n    ";
var t_6;
t_6 = (lineno = 10, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["node_modules/@discoveryedu/nebula-icons/nebula.svg#warning"]));
frame.set("status_svg_href", t_6, true);
if(frame.topLevel) {
context.setVariable("status_svg_href", t_6);
}
if(frame.topLevel) {
context.addExport("status_svg_href", t_6);
}
output += "\n";
;
}
;
}
;
}
output += "\n\n<div class=\"comet-modal__content\">\n    <div class=\"qr-block-message\">\n        <div class=\"qr-block-message__header\">\n            <div class=\"comet-row\">\n                <div class=\"comet-row__inner-flex\">\n                    <div class=\"comet-columns comet-columns--medium-12 comet-columns--large-11 comet-row__inner-flex--medium-unstack\">\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "title")) {
output += "\n                            <p class=\"qr-block-message__title\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</p>\n                        ";
;
}
output += "\n                    </div>\n                    <div class=\"comet-columns comet-columns--medium-12 comet-columns--large-1 comet-row__inner-flex--medium-unstack\">\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "is_loading")) {
output += "\n                            <div class=\"comet-spinner comet-icon comet-spinner--small\">\n                                <svg class=\"comet-spinner__icon qr-block-message__icon qr-block-message__icon--warn\" aria-labelledby=\"loading\" viewBox=\"-10 -10 220 220\">\n                                    <defs>\n                                        <linearGradient id=\"spinner-color-1\" gradientUnits=\"objectBoundingBox\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\">\n                                            <stop offset=\"0%\" stop-color=\"#7B869D\" stop-opacity=\"0\" />\n                                            <stop offset=\"100%\" stop-color=\"#7B869D\" stop-opacity=\".2\" />\n                                        </linearGradient>\n                                        <linearGradient id=\"spinner-color-2\" gradientUnits=\"objectBoundingBox\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\">\n                                            <stop offset=\"0%\" stop-color=\"#7B869D\" stop-opacity=\".2\" />\n                                            <stop offset=\"100%\" stop-color=\"#7B869D\" stop-opacity=\".4\" />\n                                        </linearGradient>\n                                        <linearGradient id=\"spinner-color-3\" gradientUnits=\"objectBoundingBox\" x1=\"1\" y1=\"0\" x2=\"0\" y2=\"1\">\n                                            <stop offset=\"0%\" stop-color=\"#7B869D\" stop-opacity=\".4\" />\n                                            <stop offset=\"100%\" stop-color=\"#7B869D\" stop-opacity=\".6\" />\n                                        </linearGradient>\n                                        <linearGradient id=\"spinner-color-4\" gradientUnits=\"objectBoundingBox\" x1=\"1\" y1=\"1\" x2=\"0\" y2=\"0\">\n                                            <stop offset=\"0%\" stop-color=\"#7B869D\" stop-opacity=\".6\" />\n                                            <stop offset=\"100%\" stop-color=\"#7B869D\" stop-opacity=\".8\" />\n                                        </linearGradient>\n                                        <linearGradient id=\"spinner-color-5\" gradientUnits=\"objectBoundingBox\" x1=\"0\" y1=\"1\" x2=\"0\" y2=\"0\">\n                                            <stop offset=\"0%\" stop-color=\"#7B869D\" stop-opacity=\".8\" />\n                                            <stop offset=\"100%\" stop-color=\"#7B869D\" stop-opacity=\"1\" />\n                                        </linearGradient>\n                                        <linearGradient id=\"spinner-color-6\" gradientUnits=\"objectBoundingBox\" x1=\"0\" y1=\"1\" x2=\"1\" y2=\"0\">\n                                            <stop offset=\"0%\" stop-color=\"#7B869D\" stop-opacity=\"1\" />\n                                            <stop offset=\"100%\" stop-color=\"#7B869D\" stop-opacity=\"1\" />\n                                        </linearGradient>\n                                    </defs>\n                                    <circle fill=\"#7B869D\" cx=\"45%\" cy=\"0\" r=\"7.5\" />\n                                    <g fill=\"none\" stroke-width=\"20\" transform=\"translate(100,100)\">\n                                        <path d=\"M 0,-100 A 100,100 0 0,1 86.6,-50\" stroke=\"url(#spinner-color-1)\" />\n                                        <path d=\"M 86.6,-50 A 100,100 0 0,1 86.6,50\" stroke=\"url(#spinner-color-2)\" />\n                                        <path d=\"M 86.6,50 A 100,100 0 0,1 0,100\" stroke=\"url(#spinner-color-3)\" />\n                                        <path d=\"M 0,100 A 100,100 0 0,1 -86.6,50\" stroke=\"url(#spinner-color-4)\" />\n                                        <path d=\"M -86.6,50 A 100,100 0 0,1 -86.6,-50\" stroke=\"url(#spinner-color-5)\" />\n                                        <path d=\"M -86.6,-50 A 100,100 0 0,1 0,-100\" stroke=\"url(#spinner-color-6)\" />\n                                    </g>\n                                </svg>\n                            </div>\n                        ";
;
}
output += "\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"qr-block-message__body\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "is_loading")) {
output += "\n            <div class=\"qr-block-message__warning\">\n                <div class=\"warning-message\">\n                    <svg class=\"warning-message__icon\" aria-hidden=\"true\" focusable=\"false\">\n                        <use xlink:href=\"";
output += runtime.suppressValue((lineno = 74, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["node_modules/@discoveryedu/nebula-icons/nebula.svg#warning"])), env.opts.autoescape);
output += "\"></use>\n                    </svg>\n                    <p>";
output += runtime.suppressValue((lineno = 76, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["DO NOT NAVIGATE AWAY FROM THIS PAGE"])), env.opts.autoescape);
output += "</p>\n                </div>\n                <p class=\"qr-block-message__text\">";
output += runtime.suppressValue((lineno = 78, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Please wait until all QR codes have been generated (this operation might take a few minutes)"])), env.opts.autoescape);
output += "</p>\n            </div>\n            ";
;
}
else {
output += "\n            <div class=\"comet-row\">\n                <div class=\"comet-row__inner-flex\">\n                    <div class=\"comet-columns comet-columns--medium-12 comet-columns--large-2 qr-block-message__icon-container\">\n                        <div>\n                            <svg class=\"qr-block-message__icon ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "status_svg_class"), env.opts.autoescape);
output += "\" aria-hidden=\"true\" focusable=\"false\">\n                                <use xlink:href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "status_svg_href"), env.opts.autoescape);
output += "\"></use>\n                            </svg>\n                        </div>\n                    </div>\n                    <div class=\"comet-columns comet-columns--medium-12 comet-columns--large-10\">\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "message") && !runtime.contextOrFrameLookup(context, frame, "is_loading")) {
output += "\n                            <p class=\"qr-block-message__text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "message"), env.opts.autoescape);
output += "</p>\n                        ";
;
}
output += "\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "is_complete") && runtime.contextOrFrameLookup(context, frame, "errors")) {
output += "\n                            <p class=\"qr-block-message__text qr-block-message__text--error\">\n                                ";
output += runtime.suppressValue((lineno = 96, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Please see the file named Error-Report.pdf which will be included with your download for additional information"])), env.opts.autoescape);
output += "\n                            </p>\n                        ";
;
}
output += "\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "sure_to_continue")) {
output += "\n                            <p class=\"qr-block-message__text qr-block-message__text--bold\">";
output += runtime.suppressValue((lineno = 100, colno = 95, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Are you sure you wish to continue?"])), env.opts.autoescape);
output += "</p>\n                        ";
;
}
output += "\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "sure_to_exit")) {
output += "\n                            <p class=\"qr-block-message__text qr-block-message__text--bold\">\n                                ";
output += runtime.suppressValue((lineno = 105, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Are you sure you wish to exit?"])), env.opts.autoescape);
output += "\n                            </p>\n                        ";
;
}
output += "\n                    </div>\n                </div>\n            </div>\n            ";
;
}
output += "\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/classrooms/templates/includes/components/_bulk_qr_block_message", function(){});

